import sample from "lodash/sample";
import range from "lodash/range";
import random from "lodash/random";
import round from "lodash/round";
import get from "lodash/get";
import moment from "moment";
import { nanoid } from "nanoid";
import { components } from './components';
import { units } from './units';
import t from '../../translate';

export function getRandomObservation() {
  const examId = sample(Object.keys(components));

  return {
    id: nanoid(3),
    code: { coding: [{ code: examId, display: t([examId, 'name']) }] },
    effectiveDateTime: moment()
      .subtract(sample(range(10)), "days")
      .subtract(sample(range(10)), "hours")
      .format(),
    component: components[examId].map((code) => ({
      code: { coding: [{ code }] },
      valueQuantity: {
        value: round(random(get(units, [code, 'range', 0], 0), get(units, [code, 'range', 1], 120)), 2),
        unit: units[code]?.unit,
      },
    })),
  };
}
